import React from "react";
import * as Yup from "yup";
import CadastroPadrao from "../../../Components/Common/CadastroPadrao";

import {
  getCondicoesPagamento,
  addNewCondicaoPagamento,
  updateCondicaoPagamento,
  deleteCondicaoPagamento
} from "../../../slices/api/condicaoPagamento";

const CondicoesPagamento = () => {
  return (
    <CadastroPadrao
      titulo="Condições de Pagamento"
      labelSingular="Condição de Pagamento"
      reduxKey="condicoesPagamento"
      acoesRedux={{
        onGet: getCondicoesPagamento,
        onAddNew: addNewCondicaoPagamento,
        onUpdate: updateCondicaoPagamento,
        onDelete: deleteCondicaoPagamento,
      }}
      colunas={[
        { campo: "id", titulo: "Código" },
        { campo: "nome", titulo: "Nome" },
      ]}
      camposFormulario={[
        {
          nome: "nome",
          label: "Nome",
          placeholder: "Informe o nome da condição de pagamento",
          validacao: Yup.string().required("Informe o nome da condição de pagamento"),
        }
      ]}
    />
  );
};

export default CondicoesPagamento;
